module.exports = __webpack_public_path__ + "8c682425aa6fdeb0b919141c6f04ce3a.svg";